import Reports from "./tabs/Reports";

const Analytics = () => {
  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <a href="#0">Dashboard</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Analytics Report
              </li>
            </ol>
          </nav>
          <div className="row">
            <Reports />
          </div>
        </div>
      </section>
    </>
  );
};

export default Analytics;
